// Controls
import { VirtualListOrientation, VirtualListWrapper } from "../virtualization/VirtualListWrapper";
// Utilities
import React, { useCallback, useEffect, useState } from "react";
/**
 * UserContainer is a wrapper around VirtualListWrapper that enables lazy loading a user when the component comes into view
 */ export function UserContainer({ user, onLoad, containerId, children }) {
    const [state, setState] = useState({
        hasLoaded: false,
        keyIndex: 0
    });
    useEffect(()=>{
        setState((prev)=>({
                hasLoaded: false,
                keyIndex: prev.keyIndex + 1
            }));
    }, [
        user
    ]);
    const handleInViewCallback = useCallback(()=>{
        setState((prev)=>{
            if (!prev.hasLoaded) {
                user && onLoad(user);
                // Updates observer key it can handle view updates
                return {
                    ...prev,
                    hasLoaded: true
                };
            }
            return prev;
        });
    }, [
        onLoad,
        user
    ]);
    return /*#__PURE__*/ React.createElement(VirtualListWrapper, {
        id: containerId,
        hasMoreItemsToRender: !state.hasLoaded,
        orientation: VirtualListOrientation.Vertical,
        onLastElementIsVisible: handleInViewCallback
    }, children);
}
